import React, { useEffect } from 'react';

import { Container, Paper } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

import { useSelectShipmentCallback } from '../../states/shipment';

import Button from '@mui/material/Button';
import ShipmentProfile from '../ShipmentProfile';

export default function ShipmentGeocodingContainer() {
  const params = useParams();
  let navigate = useNavigate();
  const selectShipment = useSelectShipmentCallback();

  useEffect(() => {
    selectShipment(params.id);
  }, [params.id]);

  const goBack = () => {
    navigate(`/incident`, { replace: true });
  };

  return (
    <Container maxWidth="xl" style={{ height: 'calc(100% - 65px)', paddingTop: '10px' }}>
      <Paper elevation={2}>
        <Container maxWidth="xl" style={{ padding: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={goBack} disableElevation size='small' color='inherit'>
            Back
          </Button>
        </Container>
        <React.Suspense fallback={<div>Loading...</div>}>
          <Container maxWidth="xl" style={{ padding: '15px' }}>
            <ShipmentProfile />
          </Container>
        </React.Suspense>
      </Paper>
    </Container>
  );
}
